import Tooltip from "@mui/material/Tooltip";
import { motion } from "framer-motion";
import React, { useMemo } from "react";
import "./IaHelpButton.css";

type IAHelpButtonProps = {
    onClick?: () => void;
    disabled?: boolean;
    loading?: boolean;
    children?: React.ReactNode;
    type?: "button" | "submit" | "reset";
    disabledTooltip?: string;
    fullWidth?: boolean;
};

function IAHelpButton({
    onClick,
    disabled,
    loading = false,
    children = "Ajuda da IA para encontrar veículo",
    type = "button",
    disabledTooltip,
    fullWidth = false,
}: IAHelpButtonProps) {

    const isDisabled = useMemo(() => disabled || loading, [disabled, loading]);
    const tooltip = useMemo(() => {
        return isDisabled ? disabledTooltip : undefined;
    }, [isDisabled, disabledTooltip]);

    return (
        <Tooltip title={tooltip} disableInteractive>
            <span className="ai-help-button-wrapper" style={{
                width: fullWidth ? "100%" : "fit-content",
            }}>
                <motion.button
                    initial={{ opacity: 0, scale: 0.98 }}
                    animate={{ opacity: 1, scale: 1 }}
                    whileHover={{ scale: isDisabled ? 1 : 1.04 }}
                    whileTap={{ scale: isDisabled ? 1 : 0.96 }}
                    transition={{ duration: 0.15 }}
                    className="ai-help-button"
                    style={{
                        width: fullWidth ? "100%" : "fit-content",
                    }}
                    onClick={onClick}
                    type={type}
                    disabled={isDisabled}
                    aria-disabled={isDisabled}
                >
                    <span style={{ width: 16 }} />
                    <motion.span
                        key="Label"
                        className="ai-help-label"
                        initial={{ opacity: 0, y: 4 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -4 }}
                        transition={{ duration: 0.15 }}
                    >
                        {children}
                    </motion.span>
                    <motion.span
                        className="ai-help-spinner"
                        aria-hidden
                        animate={{ opacity: loading ? 1 : 0 }}
                        style={{ width: 16, visibility: loading ? "visible" : "hidden" }}
                        transition={{ duration: 0.18 }}
                    />
                </motion.button>
            </span>
        </Tooltip>
    );
}

export default IAHelpButton;